import { render, staticRenderFns } from "./WhitelabledLogo.vue?vue&type=template&id=5aca0c24&scoped=true&"
import script from "./WhitelabledLogo.vue?vue&type=script&lang=js&"
export * from "./WhitelabledLogo.vue?vue&type=script&lang=js&"
import style0 from "./WhitelabledLogo.vue?vue&type=style&index=0&id=5aca0c24&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aca0c24",
  null
  
)

export default component.exports